if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations();
    }

    initializeRecommendations() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) {
          return;
        }

        observer.unobserve(this);

        const isMobile = window.matchMedia("(max-width: 749px)").matches;
        const resolvedUrl = isMobile
          ? this.dataset.urlMobile || this.dataset.url
          : this.dataset.urlDesktop || this.dataset.url;

        fetch(resolvedUrl)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("product-recommendations");

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              // Recommendations are injected after initial page load,
              // so initialize nested product image sliders in this scope.
              if (typeof initProductImageSliders === "function") {
                initProductImageSliders(this);
              }

              // Notify inventory + kluslist scripts that new product cards exist
              // so they can fetch real stock and wishlist state for these cards.
              this.dispatchEvent(new CustomEvent("recommendations:loaded", {
                bubbles: true,
                detail: { root: this }
              }));
            }

            if (html.querySelector(".card")) {
              this.classList.add("product-recommendations-loaded");
            }
          })
          .catch((error) => {
            console.error(error);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}